import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import styled from 'styled-components';
import media from './MediaQueries';
import { translate } from 'react-polyglot';

const MainButton = styled.div`
  position: absolute;
  padding: 10px;
  top: ${props => (props.priceGroupsDisplayed ? '172px' : '120px')};
  right: 30px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  ${media.phone`
    flex-direction: column;
    top: 60px;
    justify-content: center;
    z-index: 5;
  `}
  cursor: pointer;
  border-radius: 4px;
  width: 140px;
  height: 44px;
  background-color: ${props => (props.opened ? 'rgba(30,144,255,0.30)' : 'rgba(0,0,0,0.30)')};
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: white;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
`;

const FilterButtonsContainer = styled.div`
  position: absolute;
  width: 140px;
  height: 45vh;
  overflow: auto;
  top: ${props => (props.priceGroupsDisplayed ? '224px' : '172px')};
  right: 30px;
  z-index: 1;
  ${media.phone`
    top: 105px;
    z-index: 5;
  `}
  ul, li {
    list-style: none;
  }
  ul {
    display: flex;
    flex-direction: column;
    transition: transform 0.25s ease-in, opacity 0.25s ease-in;
    ${media.phone`
      opacity: 1;
      transform: translate3d(0, -20px, 0);
      margin-top: 20px;
    `}
    li {
      ${media.phone`
        width: 100%;
        height: 32px;
        font-size: 10px;
      `}
    }
  }
`;

const StyledLi = styled.li`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 44px;
  background-color: ${props => (props.active ? 'rgba(30,144,255,0.30)' : 'rgba(0,0,0,0.30)')};
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: white;
  text-align: center;
  font-size: 12px;
  font-weight: ${props => (props.active ? 800 : 500)};
  text-transform: capitalize;
  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

const Budget = styled.div`
  position: absolute;
  top: ${props => (props.priceGroupsDisplayed ? '167px' : '115px')};
  right: 20px;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: red;
  color: white;
  font-size: 15px;
  text-align: center;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  ${media.phone`
    top: 55px;
  `}
`;

class ProductFilters extends React.Component {
  constructor(props) {
    super(props);
    let productFilters = props.options.filters.filter(filter =>
      filter.inRequestProperty
        ? props.filters[filter.inRequestProperty] && props.filters[filter.inRequestProperty][filter.attribute]
        : props.filters[filter.attribute],
    );
    this.state = {
      opened: false,
      filtersSelected: productFilters.map(filter => filter.attribute),
    };
  }

  openFiltersHandler = () => {
    const { opened } = this.state;
    this.setState({
      opened: !opened,
    });
  };

  selectFilterHandler = (filter, inRequestProperty) => {
    const { filtersSelected } = this.state;
    const { toggleFilter, options, triggerCallback } = this.props;

    let newFilters = filtersSelected.slice(0);
    let filterSelected = false;
    if (options.type === 'radio') {
      // It can be only one option selected
      // se we need to deselect all the previous filters
      if (newFilters.indexOf(filter) >= 0) {
        filterSelected = false;
      } else {
        filterSelected = true;
      }
      for (const previousFilter of filtersSelected) {
        toggleFilter(previousFilter, 0, [], false, false, null, inRequestProperty, false);
      }
      newFilters = [];
      if (filterSelected) {
        newFilters.push(filter);
      }
    } else {
      if (newFilters.indexOf(filter) >= 0) {
        newFilters.splice(newFilters.indexOf(filter), 1);
      } else {
        newFilters.push(filter);
        filterSelected = true;
      }
    }
    this.setState(
      {
        filtersSelected: newFilters,
      },
      () => {
        toggleFilter(filter, filterSelected ? 1 : 0, [], false, false, null, inRequestProperty, true);
      },
    );
    triggerCallback({ callback: 'changeFilter', payload: filter });
  };

  render() {
    const { opened, filtersSelected } = this.state;
    const { options, t, configOptions } = this.props;
    return (
      <div>
        <MainButton
          className="revieve-filter-products-button"
          opened={opened}
          priceGroupsDisplayed={configOptions.results.priceGroups ? true : false}
          onClick={this.openFiltersHandler}
        >
          {options.label ? options.label : 'Filter products'}
        </MainButton>
        {filtersSelected.length > 0 && (
          <Budget
            className="revieve-filter-products-budget"
            priceGroupsDisplayed={configOptions.results.priceGroups ? true : false}
          >
            {filtersSelected.length > 9 ? '+' : filtersSelected.length}
          </Budget>
        )}
        <ReactCSSTransitionGroup
          transitionName="rightSide"
          transitionAppear={true}
          transitionEnter={true}
          transitionLeave={true}
          transitionAppearTimeout={900}
          transitionLeaveTimeout={900}
          transitionEnterTimeout={900}
        >
          {opened && (
            <FilterButtonsContainer
              className="revieve-filter-products-options"
              priceGroupsDisplayed={configOptions.results.priceGroups ? true : false}
            >
              <ul>
                {options.filters &&
                  options.filters.map((filter, i) => {
                    if (filter.type === 'subheading') {
                      return (
                        <StyledLi
                          key={i}
                          style={{
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            cursor: 'auto',
                            textTransform: 'uppercase',
                          }}
                        >
                          {filter.label}
                        </StyledLi>
                      );
                    } else {
                      let active = false;
                      if (filtersSelected.indexOf(filter.attribute) >= 0) {
                        active = true;
                      }
                      return (
                        <StyledLi
                          className={active ? 'revieve-filter-products-option-active' : null}
                          active={active}
                          key={i}
                          onClick={() => this.selectFilterHandler(filter.attribute, filter.inRequestProperty)}
                        >
                          {' '}
                          {t(filter.label)}{' '}
                        </StyledLi>
                      );
                    }
                  })}
              </ul>
            </FilterButtonsContainer>
          )}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default translate()(ProductFilters);



// WEBPACK FOOTER //
// ./src/components/instore/ProductFilters.js